import { compose } from 'redux'
import {
  Checkbox,
  Input,
  Radio,
  Dropdown,
  MoneyInput,
  RadioGroup,
} from '@cred/react-editors'
import { Link } from '@cred/react-link'
import { select, textInput, zipInput } from '@cred/react-form-field'
import { extractNumber } from '@cred/shared/utils'
import { currency } from '@cred/shared/formatters'
import { Text } from '@cred/react-text'
import PageViewAnalytics from '@cred/react-analytics/components/page-view'
import Snowplow from '@cred/react-analytics/Snowplow'
import {
  emitOnClick,
  emitOnBlur,
  emitOnChange,
  withCtaClickEvent,
  withFieldChangeEvent,
  withLinkClickEvent,
  withTooltipInteraction,
} from '@cred/react-analytics/hoc'
import { component as spContext } from '@cred/react-analytics/contexts'
import { emitGAOnClick } from '@cred/shared/hoc'
import { CtaButton, SubmitButton } from '@cred/react-button'
import { Tooltip } from '@cred/react-tooltip'
import Chips from './chips'
import { MortgagesSubmitButton } from './submit-button'
import ViewportAnalytics from './viewport-analytics'
import ViewportController from './viewport-controller'

const ctaButtonWithAnalytics = compose(
    withCtaClickEvent,
    emitOnClick,
    emitGAOnClick,
  )(CtaButton),
  MortgagesSubmitButtonWithAnalytics = compose(
    withCtaClickEvent, emitOnClick, emitGAOnClick,
  )(MortgagesSubmitButton),
  SubmitButtonWithAnalytics = compose(
    withCtaClickEvent, emitOnClick, emitGAOnClick,
  )(SubmitButton),
  selectWithAnalytics = emitOnChange(select),
  textInputWithAnalytics = emitOnBlur(textInput),
  moneyInputWithAnalytics = compose(withFieldChangeEvent)(MoneyInput),
  dropdownInputWithAnalytics = withFieldChangeEvent(Dropdown),
  radioWithAnalytics = withFieldChangeEvent(Radio),
  radioGroupWithAnalytics = withFieldChangeEvent(RadioGroup),
  linkWithAnalytics = compose(
    withLinkClickEvent, // Snowplow
    emitOnClick, // Snowplow
  )(Link),
  tooltipWithAnalytics = withTooltipInteraction(Tooltip)

export {
  Input,
  Checkbox,
  Snowplow,
  PageViewAnalytics,
  ViewportAnalytics,
  ViewportController,
  Text,
  Dropdown as NoAnalyticsDropdown,
  Chips,
  spContext,
  textInputWithAnalytics as textInput,
  selectWithAnalytics as select,
  ctaButtonWithAnalytics as CtaButton,
  radioGroupWithAnalytics as RadioGroup,
  MortgagesSubmitButtonWithAnalytics as MortgagesSubmitButton,
  SubmitButtonWithAnalytics as SubmitButton,
  moneyInputWithAnalytics as MoneyInput,
  dropdownInputWithAnalytics as Dropdown,
  radioWithAnalytics as Radio,
  linkWithAnalytics as Link,
  tooltipWithAnalytics as Tooltip,
  extractNumber,
  currency,
  zipInput,
}
